const ProfessionalHighlights = [
  {
    id: 'ph-01',
    text: 'Built and optimized real-time campaign pipelines and data sync layers at Markopolo.ai, achieving 99.9% uptime',
  },
  {
    id: 'ph-02',
    text: 'Engineered MarkTag, a cookieless first-party tracking system, boosting data accuracy by 40% while maintaining full GDPR/CCPA compliance',
  },
  {
    id: 'ph-03',
    text: 'Improved backend and frontend performance by 35% across production applications',
  },
  {
    id: 'ph-04',
    text: 'Mentored junior developers and drove clean architecture practices, increasing team productivity by 25%',
  },
];

export default ProfessionalHighlights;
